'use strict';

angular.module('app.services')

.service('Event', eventoService)
.service('Evento', eventoService); // Atalho

eventoService.$inject = ['$rootScope'];
function eventoService($rootScope) {

    /**
     * Dispara um evento
     */
    this.fire = function (/* event, arguments */)
    {
        $rootScope.$broadcast.apply($rootScope, arguments);

        return this;
    }

    /**
     * Dispara um evento
     */
    this.emit = function (/* event, arguments */) {
        this.fire.apply(this, arguments)
    }

    /**
     * Adiciona um ouvite para um determinado evento.
     * 
     * - Adicionando ouvinte globais
     * Event.on('meu:evento', function(){})
     * 
     * - Adicionando ouvinte locais
     * Event.on('meu:evento', function(){})($scope)
     * 
     * @param {string} event
     * @param {function} handler
     * @return {function} 
     */
    this.on = function (event, handler)
    {
        var removeListener = $rootScope.$on(event, handler);

        return function ($scope) {
            ($scope || $rootScope).$on('$destroy', function(){
                removeListener()
            })
        };
    }

    /**
     * Adicioan um ouvinte para ser disparado apenas uma
     * vez. Isso irá remover o ouvite após o evento ser 
     * disparado.
     * 
     * - Adicionando ouvinte globais
     * Event.on('meu:evento', function(){})
     * 
     * - Adicionando ouvinte locais
     * Event.on('meu:evento', function(){})($scope)
     * 
     * @param {string} event
     * @param {function} handler
     */
    this.once = function(event, handler)
    {
        var removeListener = $rootScope.$on(event, function(){

            handler.apply(this, arguments)

            removeListener()
        })

        return function ($scope) {
            ($scope || $rootScope).$on('$destroy', function(){
                removeListener()
            })
        };
    }

}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/services/event-service.js
// module id = 327
// module chunks = 1